import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../../../../base/components/Header';
import { useAppDispatch, useAppSelector, useBrowserBackClickHandler } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { OldPassword } from '../../components/ChangeLogin/OldPassword';
import { SetNewLogin } from '../../components/ChangeLogin/SetNewLogin';
import { Confirmation } from '../../components/ChangeLogin/Confirmation';
import { ChangeLoginStep } from '../../enums';
import { settingsActions } from '../../redux/slice/settingsSlice';
import { Helmet } from '../../../../components/Helmet';

export const ChangeLoginPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const {
        changeLogin: { step },
    } = useAppSelector((state) => state.workerAppSettings);
    const { referrer } = useAppSelector((state) => state.app);

    const [savedReferrerLocation, setSavedReferrerLocation] = useState('');

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });

        return function () {
            dispatch(settingsActions.clearData());
        };
    }, []);

    useEffect(() => {
        if (location.state?.from?.pathname) {
            setSavedReferrerLocation(location.state.from.pathname);
        }
    }, [location]);

    const onBackClick = useCallback(() => {
        if (step === ChangeLoginStep.Password) {
            if (savedReferrerLocation) {
                navigate(savedReferrerLocation);
                return;
            }
            if (referrer) {
                window.location.href = referrer;
                return;
            }
        }

        dispatch(settingsActions.setChangeLoginStep(step - 1));
    }, [step, referrer, savedReferrerLocation]);

    useBrowserBackClickHandler(onBackClick);

    const content = useMemo(() => {
        switch (step) {
            case ChangeLoginStep.Password:
                return <OldPassword />;
            case ChangeLoginStep.NewLogin:
                return <SetNewLogin />;
            case ChangeLoginStep.Confirmation:
                return <Confirmation />;
        }
    }, [step]);

    return (
        <>
            <Helmet pageName={__t('Смена логина')} />
            <div className='login-change-page'>
                <Header title={__t('Смена логина')} onBackClick={onBackClick} />
                {content}
            </div>
        </>
    );
};
